import { Col } from "reactstrap";
import { H4 } from "../../../../AbstractElements";
import { CustomBorderRadiusClass } from "../../../../Constant";
import { BORDER_CLASS } from "../../../../Data/UiKit/HelperClasses";

export const BorderRadius = () => {
  return (
    <Col xl="3" sm="6">
      <div className="border-wrapper h-100 alert-light-light dark-helper">
        <H4 className="mb-3">{CustomBorderRadiusClass}</H4>
        <div className="d-flex align-items-center mb-2 gap-2">
          <div className="helper-box b-r-0 bg-light border"></div>
          <span>.b-r-0</span>
        </div>
        {BORDER_CLASS.map((item, index) => (
          <div className="d-flex align-items-center mb-2 gap-2" key={index}>
            <div className={`helper-box ${item} bg-light border`}></div>
            <span>.{item}</span>
          </div>
        ))}
      </div>
    </Col>
  );
};
